import { useEffect, useState } from "react"
import { Grid } from '@mui/material'
import { useNavigate } from "react-router-dom"
import CustomTable from "../../components/common/CustomTable/CustomTable"
import { useCompanyStore } from "../../hooks/useCompanyStore"
import { CompanyModal } from "./components/CompanyModal"
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm"
import DescriptionIcon from '@mui/icons-material/Description'
import SettingsIcon from '@mui/icons-material/Settings'
import { company } from "../../types/slices/companyType"
import { DocumentSaleCompanyDrawer } from "./components/drawers/DocumentSaleCompanyDrawer/DocumentSaleCompanyDrawer"
import { SettingBillingDrawer } from "./components/drawers/SettingBillingDrawer/SettingBillingDrawer"

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align: 'center' },
    { type: 'text', field: 'rut', label: 'Rut', align: 'center' },
    { type: 'text', field: 'business_name', label: 'Nombre', align: 'center' },
    { type: 'text', field: 'address', label: 'Dirección', align: 'center' },
    { type: 'text', field: 'phone', label: 'Teléfono', align: 'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align: 'center' },
]

export const CompaniesView = () => {

    const navigate = useNavigate()
    // const { search } = useSelector(selectHeaderState)

    const { setActionCompany, getCompanies, deleteCompany } = useCompanyStore()

    const [loading, setLoading] = useState(false)
    const [companies, setCompanies] = useState<any>([])
    const [rowSelected, setRowSelected] = useState<any>('')
    const [showModal, setShowModal] = useState<boolean>(false)
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false)
    const [searchTimeout, setSearchTimeout] = useState<any>(null)
    const [showDocumentSales, setShowDocumentSales] = useState<boolean>(false)
    const [showSettingBilling, setShowSettingBilling] = useState<boolean>(false)

    useEffect(() => {
        getCompaniesApi()
    }, [])

    const getCompaniesApi = async (search = '') => {
        try {
            setLoading(true)
            const response = await getCompanies(search)
            if (!response) {
                setCompanies([])
                setLoading(false)
                return false
            } else {
                setCompanies(response)
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
        }
    }

    const onAdd = () => {
        setActionCompany('add')
        setShowModal(true)
    }
    const onEdit = (rowSelected: any) => {
        setActionCompany('edit')
        setRowSelected(rowSelected)
        setShowModal(true)
    }
    const onDelete = (rowSelected: any) => {
        setActionCompany('delete')
        setRowSelected(rowSelected)
        setShowModalConfirm(true)
    }
    const onDetails = (rowSelected: any) => {
        setActionCompany('detail')
        setRowSelected(rowSelected)
        setShowModal(true)
    }

    const onDeleteConfirm = async () => {
        if (rowSelected) {
            const response = await deleteCompany(rowSelected.id)
            if (response) {
                getCompaniesApi()
                setShowModalConfirm(false)
                setLoading(false)
                setRowSelected('')
            } else {
                return false
            }
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getCompaniesApi(term) }, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('')
    }

    const onHelper = (rowSelected: company): void => {
        setRowSelected(rowSelected)
        setShowDocumentSales(true)
    }

    const onHelper2 = (rowSelected: company): void => {
        setRowSelected(rowSelected)
        setShowSettingBilling(true)
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable
                    title={'Compañias'}
                    columns={columns}
                    loading={loading}
                    rows={companies || []}
                    onRowClick={() => { }}
                    hasOptions
                    onAddFn={onAdd}
                    onAddFnName={'Nueva compañia'}
                    onDetails={onDetails}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onSearch={onSearch}
                    dense

                    onHelper={onHelper}
                    tooltip_helper="Documentos de venta"
                    icon_helper={<DescriptionIcon fontSize="small" />}

                    onHelper2={onHelper2}
                    tooltip_helper2="Configuración de facturación"
                    icon_helper2={<SettingsIcon fontSize="small" />}
                />
            </Grid>
            {
                showModal && (
                    <CompanyModal
                        open={showModal}
                        closeModal={() => { setShowModal(false) }}
                        companySelected={rowSelected}
                        listCompany={getCompaniesApi}
                        clearState={clearState}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={() => { setShowModalConfirm(false); clearState() }}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            }
            {showDocumentSales && rowSelected && (
                <DocumentSaleCompanyDrawer
                    open={showDocumentSales}
                    onClose={() => { setShowDocumentSales(false) }}
                    companySelected={rowSelected}
                />
            )}
            {showSettingBilling && rowSelected && (
                <SettingBillingDrawer
                    open={showSettingBilling}
                    onClose={() => { setShowSettingBilling(false) }}
                    companySelected={rowSelected}
                />
            )}
        </>
    )
}